import { useTranslation } from "react-i18next";
import { useStorageObject } from "../../app/state/storageObjectSlice/hook/use-storage-object";
import { useServiceNavigate } from "../../app/state/storageObjectSlice/hook/use-service-navigate";
import { Sidebar } from "../../common/AppSidebar";
import { SafeOutlet } from "../../common/Protectors/SafeOutlet";
import styles from "./styles.module.css";
import { useStorageSelectors } from "../../app/state/storageObjectSlice/hook/use-storage-selectors";

export const EditorPage = () => {
  const { menuItems, selectedObject, isLoading, currentService } =
    useStorageSelectors("ai_agents_spa");
  const { addObject, handleSelectObject } = useStorageObject(
    "ai_agents_spa",
    "ai_agents_spa",
    currentService,
  );
  const { t } = useTranslation();

  useServiceNavigate("ai_agents_spa", "ai_agents_spa");

  return (
    <div className={styles["page-layout"]}>
      <Sidebar
        menuItems={menuItems}
        onAdd={() => addObject(t("editor.default_name"), "child")}
        onSelect={handleSelectObject}
        selectedId={selectedObject?.id ?? ""}
        service={"ai_agents_spa"}
        isLoading={isLoading ?? false}
      />
      {selectedObject && <SafeOutlet />}
    </div>
  );
};
